"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, FlexColumn, Input, SwitchPill, TextBody } from "@opensea/ui-kit";
import { useLocalStorage } from "@opensea/ui-kit/hooks";
import { Info } from "@opensea/ui-kit/icons";
import { Controller, useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { useChainArch } from "../../../../../polychain/hooks/useChainArch";
import { getDefaultSlippage, getMaxSlippageStorageKey } from "../../constants";
import { useSwapContext } from "../../provider/SwapContext";
import { MaxSlippageTooltip } from "../SwapDetails/components/MaxSlippageTooltip";
export function MaxSlippageInput() {
  const $ = _c(18);
  const t = useTranslations("wallet.MaxSlippageInput");
  const {
    control
  } = useFormContext();
  let t0;
  if ($[0] !== control) {
    t0 = {
      control
    };
    $[0] = control;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    errors
  } = useFormState(t0);
  const {
    isAutoSlippageEnabled,
    toggleAutoSlippage
  } = useSwapContext();
  let t1;
  if ($[2] !== control) {
    t1 = {
      control,
      name: "maxSlippage"
    };
    $[2] = control;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const maxSlippage = useWatch(t1);
  const chainArch = useChainArch();
  let t2;
  if ($[4] !== chainArch) {
    t2 = getDefaultSlippage(chainArch);
    $[4] = chainArch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const defaultSlippage = t2;
  let t3;
  if ($[6] !== chainArch) {
    t3 = getMaxSlippageStorageKey(chainArch);
    $[6] = chainArch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [, setStoredMaxSlippage] = useLocalStorage(t3, defaultSlippage);
  let t4;
  if ($[8] !== errors.maxSlippage || $[9] !== isAutoSlippageEnabled || $[10] !== maxSlippage || $[11] !== setStoredMaxSlippage || $[12] !== t || $[13] !== toggleAutoSlippage) {
    t4 = t5 => {
      const {
        field: maxSlippageField
      } = t5;
      return <FlexColumn className="ml-1 gap-1"><FlexCenter className="items-center justify-between gap-4"><MaxSlippageTooltip><span><FlexCenter className="gap-1.5"><TextBody className="whitespace-nowrap">{t("label")}</TextBody><Info fill="text-secondary" size={16} /></FlexCenter></span></MaxSlippageTooltip><Input className="gap-2.5" endEnhancer="%" max={100} onChange={e => {
            if (isAutoSlippageEnabled) {
              toggleAutoSlippage();
            }
            const newValue = e.target.value ? Number.parseFloat(e.target.value) : undefined;
            maxSlippageField.onChange(newValue);
            if (newValue !== undefined) {
              setStoredMaxSlippage(newValue);
            }
          }} size="sm" startEnhancer={<SwitchPill checked={isAutoSlippageEnabled} onClick={toggleAutoSlippage} variant="primary">{t("auto")}</SwitchPill>} step={0.01} type="number" value={maxSlippage} /></FlexCenter>{errors.maxSlippage?.message && <TextBody className="w-full break-words" color="error-1" size="xs">{errors.maxSlippage.message}</TextBody>}</FlexColumn>;
    };
    $[8] = errors.maxSlippage;
    $[9] = isAutoSlippageEnabled;
    $[10] = maxSlippage;
    $[11] = setStoredMaxSlippage;
    $[12] = t;
    $[13] = toggleAutoSlippage;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== control || $[16] !== t4) {
    t5 = <Controller control={control} name="maxSlippage" render={t4} />;
    $[15] = control;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}